import tasks from '@/modules/road-maintenance-module/tasks/routes/index.child'
import task from '@/modules/road-maintenance-module/tasks/routes/show.child'
import reports from '@/modules/road-maintenance-module/reports/routes/index.child'
import reportBase from '@/modules/road-maintenance-module/report-base/routes/index.child'
import ActiveWorkOrders from '@/modules/road-maintenance-module/patrol-service/routes/active.child'
import InactiveWorkOrders from '@/modules/road-maintenance-module/patrol-service/routes/inactive.child'
import ExcavationActiveWorkOrders from '@/modules/road-maintenance-module/excavation-service/routes/active.child'
import ExcavationInactiveWorkOrders from '@/modules/road-maintenance-module/excavation-service/routes/inactive.child'
import ExcavationStakeholders from '@/modules/road-maintenance-module/excavation-settings/routes/stakeholders.child'
import ExcavationResponsiblePersonOfTheInvestor from '@/modules/road-maintenance-module/excavation-settings/routes/responsible_person_of_the_investor.child'
import ExcavationResponsiblePersonOfZagrebRoads from '@/modules/road-maintenance-module/excavation-settings/routes/responsible_person_of_zagreb_roads.child'
import ExcavationQuarters from '@/modules/road-maintenance-module/excavation-settings/routes/quarters.child'
import ExcavationDistrictOffices from '@/modules/road-maintenance-module/excavation-settings/routes/district_offices.child'
import ExcavationRoadCategories from '@/modules/road-maintenance-module/excavation-settings/routes/road_categories.child'
import ExcavationPurposesOfExcavations from '@/modules/road-maintenance-module/excavation-settings/routes/purposes_of_excavation.child'
import patrolVehicleServiceWorkOrders from '@/modules/road-maintenance-module/patrol-vehicle-service/routes/index.child'
import TrafficLightsIndex from '@/modules/road-maintenance-module/traffic-lights/routes/index.child'
import PatrolSubscriptionSettings from '@/modules/road-maintenance-module/patrol-settings/subscriptions/routes/index.child'
import PrpIndex from '@/modules/road-maintenance-module/prp/routes/index.child'

// **** E-REGULATION MENU ****
import AggregatorRequests from '@/modules/road-maintenance-module/aggregator/requests/routes/index.child'
import AggregatorRoads from '@/modules/road-maintenance-module/aggregator/roads/routes/index.child'
import AggregatorRequestsDetails from '@/modules/road-maintenance-module/aggregator/requests/routes/show.child'
import AggregatorSolutions from '@/modules/road-maintenance-module/aggregator/solutions/routes/index.child'
import AggregatorSolutionDetails from '@/modules/road-maintenance-module/aggregator/solutions/routes/show.child'
import AggregatorApprovals from '@/modules/road-maintenance-module/aggregator/approvals/routes/index.child'
import AggregatorApprovalDetails from '@/modules/road-maintenance-module/aggregator/approvals/routes/show.child'
import AggregatorRoadInformation from '@/modules/road-maintenance-module/aggregator/road-information/routes/index.child'
import AggregatorRoadInformationDetails from '@/modules/road-maintenance-module/aggregator/road-information/routes/show.child'
import AggregatorReports from '@/modules/road-maintenance-module/aggregator/reports/routes/index.child'

// **** WORK ORDERS MENU ****

// **** TEMPORARY REGULATIONS MENU ****
import TemporaryRegulationsRequests from '@/modules/road-maintenance-module/temporary-regulations/requests/routes/index.child'
import TemporaryRegulationsRequestDetails from '@/modules/road-maintenance-module/temporary-regulations/requests/routes/show.child'
import TemporaryRegulationsWorkOrders from '@/modules/road-maintenance-module/temporary-regulations/work-orders/routes/index.child'
import TemporaryRegulationsWorkOrderDetails from '@/modules/road-maintenance-module/temporary-regulations/work-orders/routes/show.child'
import TemporaryRegulationsProducts from '@/modules/road-maintenance-module/settings/products/routes/index.child'
import TemporaryRegulationsProductsDetails from '@/modules/road-maintenance-module/settings/products/routes/show.child'
import TemporaryRegulationsLocations from '@/modules/road-maintenance-module/settings/locations/routes/index.child'
import TemporaryRegulationsProductCategories from '@/modules/road-maintenance-module/settings/product-categories/routes/index.child'
import TemporaryRegulationsActivities from '@/modules/road-maintenance-module/settings/activities/routes/index.child'
import TemporaryRegulationsConstructionSites from '@/modules/road-maintenance-module/settings/construction-sites/routes/index.child'
import TemporaryRegulationsRoads from '@/modules/road-maintenance-module/settings/roads/routes/index.child'
import TemporaryRegulationsTags from '@/modules/road-maintenance-module/settings/tags/routes/index.child'
import TemporaryRegulationsTagsConfiguration from '@/modules/road-maintenance-module/settings/tags-configuration/routes/index.child'
import TemporaryRegulationsCrews from '@/modules/road-maintenance-module/temporary-regulations/crews/routes/index.child'
import TemporaryRegulationsCrewDetails from '@/modules/road-maintenance-module/temporary-regulations/crews/routes/show.child'
import TemporaryRegulationsCrewScheduling from '@/modules/road-maintenance-module/temporary-regulations/crew-scheduling/routes/index.child'
import TemporaryRegulationsItemExecution from '@/modules/road-maintenance-module/temporary-regulations/item-execution/routes/index.child'
import TemporaryRegulationsItemExecutionDetails from '@/modules/road-maintenance-module/temporary-regulations/item-execution/routes/show.child'

// **** WINTER SERVICE V2 MENU ****
import WinterService2SettingsIrregularities from '@/modules/road-maintenance-module/winter-service-v2/settings/irregularities/routes/index.child'
import WinterService2Subcontractors from '@/modules/road-maintenance-module/winter-service-v2/subcontractors/routes/index.child'
import WinterService2SubcontractorDetails from '@/modules/road-maintenance-module/winter-service-v2/subcontractors/routes/show.child'
import WinterService2Bases from '@/modules/road-maintenance-module/winter-service-v2/bases/routes/index.child'
import WinterService2BaseDetails from '@/modules/road-maintenance-module/winter-service-v2/bases/routes/show.child'
import WinterService2Book from '@/modules/road-maintenance-module/winter-service-v2/book/routes/index.child'
import WinterService2WorkOrdersStatus from '@/modules/road-maintenance-module/winter-service-v2/work-orders/status/routes/index.child'
import WinterService2WorkOrdersOverview from '@/modules/road-maintenance-module/winter-service-v2/work-orders/overview/routes/index.child'
import WinterService2WorkOrderDetails from '@/modules/road-maintenance-module/winter-service-v2/work-orders/overview/routes/show.child'
import WinterService2Report from '@/modules/road-maintenance-module/winter-service-v2/reports/routes/index.child'
import WinterService2Irregularities from '@/modules/road-maintenance-module/winter-service-v2/irregularities/routes/index.child'
import WinterService2IrregularityDetails from '@/modules/road-maintenance-module/winter-service-v2/irregularities/routes/show.child'
import WinterService2Tasks from '@/modules/road-maintenance-module/winter-service-v2/tasks/routes/index.child'
import WinterService2TaskCreate from '@/modules/road-maintenance-module/winter-service-v2/tasks/routes/create.child'
import WinterService2TaskDetails from '@/modules/road-maintenance-module/winter-service-v2/tasks/routes/show.child'
import WinterService2Requests from '@/modules/road-maintenance-module/winter-service-v2/requests/routes/index.child'
import WinterService2RequestCreate from '@/modules/road-maintenance-module/winter-service-v2/requests/routes/create.child'
import WinterService2RequestDetails from '@/modules/road-maintenance-module/winter-service-v2/requests/routes/show.child'

export default {
  path: '/road-maintenance',
  redirect: {
    name: 'NotFound',
    params: {
      pathMatch: '/road-maintenance'
    }
  },
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../views/RoadMaintenanceView.vue'),
  meta: {
    exclude: false,
    requiresAuth: true
  },
  children: [
    tasks,
    task,
    reports,
    reportBase,
    ActiveWorkOrders,
    InactiveWorkOrders,
    patrolVehicleServiceWorkOrders,
    ExcavationActiveWorkOrders,
    ExcavationInactiveWorkOrders,
    ExcavationStakeholders,
    ExcavationResponsiblePersonOfTheInvestor,
    ExcavationResponsiblePersonOfZagrebRoads,
    ExcavationQuarters,
    ExcavationDistrictOffices,
    ExcavationRoadCategories,
    ExcavationPurposesOfExcavations,
    TrafficLightsIndex,
    PatrolSubscriptionSettings,
    AggregatorRequests,
    AggregatorRoads,
    AggregatorSolutions,
    AggregatorApprovals,
    AggregatorRequestsDetails,
    AggregatorSolutionDetails,
    AggregatorApprovalDetails,
    AggregatorRoadInformation,
    AggregatorRoadInformationDetails,
    AggregatorReports,
    PrpIndex,
    TemporaryRegulationsRequests,
    TemporaryRegulationsRequestDetails,
    TemporaryRegulationsWorkOrders,
    TemporaryRegulationsWorkOrderDetails,
    TemporaryRegulationsProducts,
    TemporaryRegulationsProductsDetails,
    TemporaryRegulationsLocations,
    TemporaryRegulationsProductCategories,
    TemporaryRegulationsActivities,
    TemporaryRegulationsConstructionSites,
    TemporaryRegulationsRoads,
    TemporaryRegulationsTags,
    TemporaryRegulationsTagsConfiguration,
    TemporaryRegulationsCrews,
    TemporaryRegulationsCrewDetails,
    TemporaryRegulationsCrewScheduling,
    TemporaryRegulationsItemExecution,
    TemporaryRegulationsItemExecutionDetails,
    WinterService2SettingsIrregularities,
    WinterService2Subcontractors,
    WinterService2SubcontractorDetails,
    WinterService2Bases,
    WinterService2BaseDetails,
    WinterService2Book,
    WinterService2WorkOrdersStatus,
    WinterService2WorkOrdersOverview,
    WinterService2WorkOrderDetails,
    WinterService2Report,
    WinterService2Irregularities,
    WinterService2IrregularityDetails,
    WinterService2Tasks,
    // Before the details route - `create` would otherwise be matched as a task id.
    WinterService2TaskCreate,
    WinterService2TaskDetails,
    WinterService2Requests,
    // Before the details route - `create` would otherwise be matched as a request id.
    WinterService2RequestCreate,
    WinterService2RequestDetails
  ]
}
